import React from 'react';

const SvgActHumbleAndRespectful = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 104 104"
}, props), /*#__PURE__*/React.createElement("g", {
  className: "tourlane-CoreValues-ActHumbleAndRespectful__nc-icon-wrapper"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "tourlane-CoreValues-ActHumbleAndRespectful__path-1",
  d: "M38.416 0c21.217 0 38.417 17.2 38.417 38.416 0-4.243-5.733-7.683-12.806-7.683-6.956 0-12.617 3.328-12.8 7.475l-.005.208c0-4.243-5.733-7.683-12.806-7.683-6.956 0-12.617 3.328-12.8 7.475l-.005.208c0-4.243-5.733-7.683-12.806-7.683-6.956 0-12.617 3.328-12.8 7.475L0 38.416C0 17.2 17.2 0 38.416 0z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M56.085 16.013a3.88 3.88 0 00.173-1.15c0-2.134-1.72-3.863-3.842-3.863-2.121 0-3.841 1.73-3.841 3.863 0 .44.073.864.209 1.26l7.3-.11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M52.416 45.01c.512 0 .935.38 1.002.873l.01.137v38.417a6.133 6.133 0 01-12.26.288l-.007-.288v-.695a1.011 1.011 0 012.013-.137l.009.137v.695a4.111 4.111 0 008.216.241l.007-.241V46.02c0-.558.452-1.01 1.01-1.01z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(14 15.287)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-CoreValues-ActHumbleAndRespectful__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-CoreValues-ActHumbleAndRespectful__path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#59DD7D",
  xlinkHref: "#tourlane-CoreValues-ActHumbleAndRespectful__path-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50C871",
  d: "M25.611 36.778v-7.96A39.618 39.618 0 0138.043 0c7.934-7.485-7.305-7.485.63 0a39.618 39.618 0 0112.431 28.818v7.455l-25.493.505z",
  mask: "url(#tourlane-CoreValues-ActHumbleAndRespectful__mask-2)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M52.416 68.77a2.561 2.561 0 012.555 2.37l.007.19v13.107a7.683 7.683 0 01-15.362.288l-.005-.288v-.695a2.561 2.561 0 015.115-.19l.007.19v.695a2.561 2.561 0 005.115.19l.007-.19V71.33a2.561 2.561 0 012.561-2.561z"
}))));

export default SvgActHumbleAndRespectful;